export default __webpack_public_path__ + "static/media/high-fid.2b800cc3.png";